module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-section"
  }, [_c('div', {
    staticClass: "issues-header"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("\n      Priority Issues\n      "), _c('span', {
    staticClass: "need-action-badge"
  }, [_vm._v(_vm._s(_vm.needActionCount) + " Need Action")])]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('button', {
    staticClass: "export-button",
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": function($event) {
        return _vm.$emit('export')
      }
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n        " + _vm._s(_vm.exporting ? 'Exporting…' : 'Export CSV') + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "view-all-link",
    on: {
      "click": function($event) {
        return _vm.$emit('viewAll')
      }
    }
  }, [_vm._v("\n        View all " + _vm._s(_vm.totalIssues) + " issues >\n      ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section-dev-notes"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "issues-list"
  }, _vm._l((_vm.issues), function(issue, index) {
    return _c('div', {
      key: index,
      staticClass: "issue-row"
    }, [_c('div', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-image-wrap"
    }, [_c('div', {
      staticClass: "product-image-placeholder"
    }), _vm._v(" "), (issue.imageUrl) ? _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": issue.imageUrl,
        "alt": issue.product
      },
      on: {
        "error": function (e) { return e.target.style.display = 'none'; }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name-line"
    }, [_c('span', {
      staticClass: "product-name clickable",
      on: {
        "click": function($event) {
          return _vm.$emit('product-click', issue)
        }
      }
    }, [_vm._v(_vm._s(issue.product))])]), _vm._v(" "), (issue.asin) ? _c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(issue.asin))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "status-cell"
    }, [_c('span', {
      staticClass: "issue-status",
      class: issue.statusType
    }, [_vm._v(_vm._s(issue.status))])]), _vm._v(" "), _c('div', {
      staticClass: "impact-cell"
    }, [_c('span', {
      staticClass: "impact-value",
      class: issue.impactClass
    }, [_vm._v(_vm._s(issue.impact))])]), _vm._v(" "), _c('div', {
      staticClass: "action-cell"
    }, [_c('a', {
      staticClass: "view-details-link",
      on: {
        "click": function($event) {
          return _vm.$emit('action-click', issue)
        }
      }
    }, [_vm._v("\n          View Details >\n        ")])])])
  }), 0), _vm._v(" "), (_vm.syncing) ? _c('div', {
    staticClass: "sync-issues-note"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#2980b9",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Buy Box issues will appear here once the scan completes.")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-table-header"
  }, [_c('span', [_vm._v("PRODUCT")]), _vm._v(" "), _c('span', [_vm._v("STATUS")]), _vm._v(" "), _c('span', {
    staticClass: "est-daily-header"
  }, [_vm._v("\n      EST. DAILY\n      "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Estimated daily revenue impact"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ACTION")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7949272!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/PriorityIssuesList.vue
// module id = 814
// module chunks = 2